import type { ReactNode } from 'react';

// Returns ReactNode — NOT JSX.Element (Hot #114)
function highlightMatch(text: string, query: string): ReactNode {
  if (!query.trim()) return text;
  const idx = text.toLowerCase().indexOf(query.toLowerCase());
  if (idx === -1) return text;
  return (
    <>
      {text.slice(0, idx)}
      <mark className="search-match-highlight">{text.slice(idx, idx + query.length)}</mark>
      {text.slice(idx + query.length)}
    </>
  );
}

interface SymbolCellProps {
  symbol: string;
  query: string;
}

export default function SymbolCell({ symbol, query }: SymbolCellProps): ReactNode {
  return <td className="symbol-cell">{highlightMatch(symbol, query)}</td>;
}
